import {Observable} from "rxjs";
import {Token} from "./token.interface";
import {Request} from "../request.abstract";

export class Authentication extends Request {
    token(username: string, password: string): Observable<Token> {
        return this.post('/v1/authentication/token', {
            "grant_type" : "password",
            "username"   : username,
            "password"   : password
        }) as Observable<Token>;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/authentication/api.service.ts